import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { Box, Typography } from '@material-ui/core'
import { getLevelArray } from '../utils'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'block',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  blockWrapper: {
    flex: '0px 1 1',
    '& .MuiTypography-root': {
      // textTransform: 'lowercase',
      textAlign: 'center',
      marginTop: theme.spacing(0.25),
    },
    '&:nth-child(1) $block': {
      backgroundColor: theme.extras.ratings.levelColors[0],
    },
    '&:nth-child(2) $block': {
      backgroundColor: theme.extras.ratings.levelColors[1],
    },
    '&:nth-child(3) $block': {
      backgroundColor: theme.extras.ratings.levelColors[2],
    },
    '&:nth-child(4) $block': {
      backgroundColor: theme.extras.ratings.levelColors[3],
    },
    '&:nth-child(5) $block': {
      backgroundColor: theme.extras.ratings.levelColors[4],
    },
    '&:not(:last-child)': {
      marginRight: 5,
    },
  },
  block: {
    height: 8,
    borderRadius: 2,
  },
}))

/**
 * Static scale that renders quintiles as colored blocks.
 */
const LevelScale = ({ ...props }) => {
  const classes = useStyles()

  return (
    <Box
      className={clsx('level-scale-parent', classes.root)}
    >
      {getLevelArray().map((el, i) => (
        <Box
          className={classes.blockWrapper}
          key={`level-scale-block-${i}`}
        >
          <Box className={classes.block}></Box>
          <Typography
            color="textSecondary"
            variant="caption"
            component="p"
          >
            {el}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

LevelScale.propTypes = {}

export default LevelScale
